// Central UI translations dictionary. Screens use useT() to render.

export const STRINGS = {
  // Global
  back: { en: "Back", es: "Atrás" },
  continue: { en: "Continue", es: "Continuar" },
  next: { en: "Continue", es: "Continuar" },
  cancel: { en: "Cancel", es: "Cancelar" },
  loading: { en: "Loading…", es: "Cargando…" },
  optional: { en: "optional", es: "opcional" },

  // Language chooser
  lang_continue_en: { en: "Continue in English", es: "Continue in English" },
  lang_continue_es: { en: "Continuar en Español", es: "Continuar en Español" },
  lang_tagline: { en: "Choose your language", es: "Elige tu idioma" },

  // Welcome / Onboarding
  scl_indianapolis: { en: "Indianapolis", es: "Indianápolis" },
  scl_challenge_label: { en: "Kindness Challenge", es: "Desafío de Bondad" },
  welcome_hero_title: { en: "Welcome to the Kindness Challenge.", es: "Bienvenido al Desafío de Bondad." },
  welcome_hero_lead: { en: "Complete kindness challenges, earn points, and win prizes — all while making Indianapolis a little better.", es: "Completa desafíos de bondad, gana puntos y premios — haciendo a Indianápolis un poco mejor." },
  welcome_hero_tag: { en: "Kindness starts here.", es: "La bondad empieza aquí." },
  welcome_hero_kicker: { en: "Socially Engaged Education", es: "Educación Comprometida con la Comunidad" },
  step_of: { en: "Step {n} of 3", es: "Paso {n} de 3" },
  first_name: { en: "First name", es: "Nombre" },
  last_name: { en: "Last name", es: "Apellido" },
  email: { en: "Email", es: "Correo electrónico" },
  email_help: { en: "So we can send your prize + kindness updates.", es: "Para enviarte tu premio + novedades de bondad." },
  phone_number: { en: "Phone number", es: "Teléfono" },
  phone_help: { en: "Optional — for text reminders about upcoming SCL events.", es: "Opcional — para recordatorios de eventos de SCL." },
  grade_label: { en: "Child's grade level", es: "Grado de tu hijo/a" },
  grade_placeholder: { en: "Pick a grade", es: "Elige un grado" },
  consent_contact: { en: "I give permission for SCL to contact me about enrollment and community events.", es: "Doy permiso a SCL para contactarme sobre inscripción y eventos comunitarios." },
  consent_media: { en: "I give permission for SCL to use my uploaded photos/videos for marketing and social media purposes.", es: "Doy permiso a SCL para usar mis fotos/videos en marketing y redes sociales." },
  cta_lets_go: { en: "Let's Go!", es: "¡Vamos!" },
  cta_signing_up: { en: "Signing you up…", es: "Registrándote…" },
  toast_welcome: { en: "You're in! Pick a path.", es: "¡Bienvenido! Elige un camino." },
  toast_form_error: { en: "Please fill out the required fields", es: "Por favor completa los campos requeridos" },
  toast_signup_fail: { en: "Couldn't sign you up — try again", es: "No pudimos registrarte — intenta de nuevo" },

  // Home / path chooser
  home_kicker: { en: "SCL · Two ways to play", es: "SCL · Dos formas de jugar" },
  home_welcome_name: { en: "Welcome, {name}.", es: "Hola, {name}." },
  home_lead: { en: "Pick a path. Do good in your community, or discover a family activity to do with your kids today.", es: "Elige un camino. Haz el bien en tu comunidad, o descubre una actividad familiar para hacer con tus hijos hoy." },
  path_kindness_title: { en: "Kindness Challenge", es: "Desafío de Bondad" },
  path_kindness_sub: { en: "Do good, earn points, win prizes.", es: "Haz el bien, gana puntos, gana premios." },
  path_kindness_pill: { en: "Earn points · Win prizes", es: "Gana puntos · Gana premios" },
  path_activities_title: { en: "Family Activity Spinner", es: "Ruleta de Actividades Familiares" },
  path_activities_sub: { en: "Find something fun to do with your kids.", es: "Encuentra algo divertido para hacer con tus hijos." },
  path_activities_pill: { en: "Discover · No upload", es: "Descubre · Sin subir" },
  footer_project: { en: "A project of", es: "Un proyecto de" },
  footer_explore: { en: "Explore more at schoolforcommunitylearning.org", es: "Explora más en schoolforcommunitylearning.org" },
  scan_to_join: { en: "Scan to Join", es: "Escanea para unirte" },
  view_qr: { en: "Event QR codes", es: "Códigos QR del evento" },

  // Gallery
  gallery_kicker: { en: "Kindness Challenge", es: "Desafío de Bondad" },
  gallery_title: { en: "Pick a challenge, {name}.", es: "Elige un desafío, {name}." },
  gallery_lead: { en: "Every act counts. Every act earns points.", es: "Cada acto cuenta. Cada acto gana puntos." },

  // Detail
  detail_how: { en: "How to do it", es: "Cómo hacerlo" },
  detail_reminder: { en: "When you're done, snap a photo or short video as proof. That's what unlocks your points.", es: "Cuando termines, toma una foto o un video corto como prueba. Eso desbloquea tus puntos." },
  detail_accept: { en: "Accept this challenge", es: "Aceptar este desafío" },

  // Submit
  submit_kicker: { en: "Your challenge", es: "Tu desafío" },
  submit_title: { en: "Record or upload your kindness moment.", es: "Graba o sube tu momento de bondad." },
  submit_dropzone_title: { en: "Record or upload your kindness moment", es: "Graba o sube tu momento de bondad" },
  submit_dropzone_help: { en: "Photos up to 10 MB · Videos up to 100 MB", es: "Fotos hasta 10 MB · Videos hasta 100 MB" },
  submit_use_camera: { en: "Use camera", es: "Usar cámara" },
  submit_choose_file: { en: "Choose file", es: "Elegir archivo" },
  submit_caption: { en: "Caption (optional)", es: "Descripción (opcional)" },
  submit_caption_placeholder: { en: "Tell us what happened…", es: "Cuéntanos qué pasó…" },
  submit_notice: { en: "By submitting, you confirm you have permission to share this content and agree to SCL's media use policy.", es: "Al enviar, confirmas que tienes permiso para compartir este contenido y aceptas la política de uso de medios de SCL." },
  submit_uploading: { en: "Uploading…", es: "Subiendo…" },
  submit_button: { en: "Submit my challenge!", es: "¡Enviar mi desafío!" },
  submit_success_headline: { en: "Amazing! You earned {n} points.", es: "¡Increíble! Ganaste {n} puntos." },
  submit_success_sub: { en: "Keep the kindness going. One act at a time — Indianapolis notices.", es: "Sigue con la bondad. Un acto a la vez — Indianápolis se da cuenta." },
  points_plus: { en: "+{n} points", es: "+{n} puntos" },
  continue_to_mine: { en: "Continue to my challenges →", es: "Ver mis desafíos →" },
  cloudinary_warning: { en: "Media uploads aren't configured yet. Ask the SCL team to set the Cloudinary keys before submitting.", es: "Las subidas de media no están configuradas. Pide al equipo SCL configurar Cloudinary antes de enviar." },

  // Progress / Leaderboard
  progress_kicker: { en: "Your journey", es: "Tu recorrido" },
  progress_title: { en: "Kindness, tracked.", es: "Bondad, registrada." },
  tab_mine: { en: "My Challenges", es: "Mis Desafíos" },
  tab_board: { en: "Leaderboard", es: "Tabla de Líderes" },
  empty_mine: { en: "You haven't finished a challenge yet. Browse the deck to start.", es: "Aún no completas ningún desafío. Explora el catálogo para empezar." },
  empty_browse: { en: "Browse challenges", es: "Explorar desafíos" },
  top_10: { en: "Top 10 · Live", es: "Top 10 · En vivo" },
  be_first: { en: "Be the first on the board.", es: "Sé el primero en la clasificación." },
  pick_another: { en: "Pick another challenge", es: "Elige otro desafío" },
  approved: { en: "Approved", es: "Aprobado" },
  pending: { en: "Pending", es: "Pendiente" },

  // Activities
  activities_kicker: { en: "Family Activity Spinner", es: "Ruleta de Actividades" },
  activities_title: { en: "What should we do with the kids today?", es: "¿Qué hacemos con los niños hoy?" },
  activities_lead: { en: "SCL-approved family ideas — hands-on, community-connected, low-cost.", es: "Ideas familiares aprobadas por SCL — prácticas, comunitarias, económicas." },
  filter_when: { en: "When", es: "Cuándo" },
  filter_where: { en: "Where", es: "Dónde" },
  filter_who: { en: "Who", es: "Quién" },
  filter_cost: { en: "Cost", es: "Costo" },
  filter_any: { en: "Any", es: "Cualquiera" },
  filter_weekday: { en: "Weekday", es: "Entre semana" },
  filter_weekend: { en: "Weekend", es: "Fin de semana" },
  filter_indoor: { en: "Indoor", es: "Interior" },
  filter_outdoor: { en: "Outdoor", es: "Exterior" },
  filter_family: { en: "Family", es: "Familia" },
  filter_group: { en: "Group", es: "Grupo" },
  filter_free: { en: "Free", es: "Gratis" },
  filter_low: { en: "Low Cost", es: "Bajo costo" },
  activities_count: { en: "{n} activities match your filters", es: "{n} actividades coinciden con tus filtros" },
  activities_count_one: { en: "{n} activity matches your filters", es: "{n} actividad coincide con tus filtros" },
  activity_spin: { en: "Spin for an activity!", es: "¡Gira por una actividad!" },
  spinning: { en: "Spinning…", es: "Girando…" },
  spin_again: { en: "Spin again", es: "Girar de nuevo" },
  activity_idea: { en: "Activity idea", es: "Idea de actividad" },
  activity_bonus_label: { en: "Bonus · While You're There", es: "Extra · Mientras estás ahí" },

  // Guide unlock gate
  unlock_kicker: { en: "Unlock this activity", es: "Desbloquea esta actividad" },
  unlock_headline: { en: "Enter your email to see the full activity + get the free SCL Summer Family Activity Guide.", es: "Ingresa tu correo para ver la actividad completa + recibir la Guía de Verano gratis de SCL." },
  unlock_email: { en: "Email", es: "Correo electrónico" },
  unlock_phone: { en: "Phone", es: "Teléfono" },
  unlock_phone_help: { en: "Optional — for SMS updates about SCL events.", es: "Opcional — para avisos por SMS de eventos SCL." },
  unlock_button: { en: "Unlock + get the guide", es: "Desbloquear + recibir la guía" },
  unlock_sending: { en: "Unlocking…", es: "Desbloqueando…" },
  unlock_success: { en: "Unlocked! Your guide is ready.", es: "¡Desbloqueado! Tu guía está lista." },
  unlock_email_invalid: { en: "Please enter a valid email", es: "Ingresa un correo válido" },
  guide_download: { en: "Download the Activity Guide (PDF)", es: "Descargar la Guía de Actividades (PDF)" },
  guide_note: { en: "18 SCL-approved activities for the whole summer.", es: "18 actividades aprobadas por SCL para todo el verano." },

  // Apply CTA
  apply_kicker: { en: "School for Community Learning", es: "School for Community Learning" },
  apply_headline: { en: "Love what SCL is about?", es: "¿Te encanta lo que hace SCL?" },
  apply_body: { en: "See if SCL is the right fit for your family — request enrollment info now.", es: "Descubre si SCL es lo indicado para tu familia — solicita información de inscripción ahora." },
  apply_button: { en: "Apply to SCL", es: "¡Solicita a SCL!" },

  // Nav
  nav_home: { en: "Home", es: "Inicio" },
  nav_challenges: { en: "Challenges", es: "Desafíos" },
  nav_activities: { en: "Activities", es: "Actividades" },
  nav_progress: { en: "Progress", es: "Progreso" },
  nav_signout: { en: "Sign out", es: "Cerrar sesión" },

  // QR screen
  qr_title: { en: "Scan to Join", es: "Escanea para unirte" },
  qr_lead: { en: "Point a phone camera at either code to jump straight into a path.", es: "Apunta con la cámara del teléfono a cualquier código para ir directo a un camino." },
  qr_label_kindness: { en: "Kindness Challenge", es: "Desafío de Bondad" },
  qr_label_spinner: { en: "Activity Guide", es: "Guía de Actividades" },

  // Kindness Wall
  wall_kicker: { en: "Public Kindness Wall", es: "Muro Público de Bondad" },
  wall_title: { en: "Real moments from real people.", es: "Momentos reales de gente real." },
  wall_empty: { en: "No public submissions yet. Be the first to share.", es: "Aún no hay publicaciones públicas. Sé el primero en compartir." },
  wall_back: { en: "Back to app", es: "Volver a la app" },
  wall_pts_by: { en: "{name} · +{n} pts", es: "{name} · +{n} pts" },
  open: { en: "Open", es: "Abrir" },
  diff_Easy:   { en: "Easy", es: "Fácil" },
  diff_Medium: { en: "Medium", es: "Medio" },
  diff_Go_Big: { en: "Go Big", es: "A lo grande" },

  points_worth: { en: "{n} pts", es: "{n} pts" },

  // Native enrollment / intake form
  intake_kicker_parents:  { en: "Unlock the SCL Parents Guide", es: "Desbloquea la Guía para Padres SCL" },
  intake_kicker_activity: { en: "Unlock your family activity guide", es: "Desbloquea tu guía de actividades" },
  intake_lead_parents:    { en: "Tell us who you are and we will email the guide plus a way to book a school tour.", es: "Dinos quién eres y te enviaremos la guía y un enlace para reservar un recorrido." },
  intake_lead_activity:   { en: "Add your details to grab this week's Family Activity Guide.", es: "Agrega tus datos para obtener la Guía de Actividades Familiares de esta semana." },
  intake_name:            { en: "Parent name", es: "Nombre del padre/madre" },
  intake_name_ph:         { en: "First and last name", es: "Nombre y apellido" },
  intake_email:           { en: "Email", es: "Correo electrónico" },
  intake_phone:           { en: "Phone", es: "Teléfono" },
  intake_phone_ph:        { en: "(317) 555-0123", es: "(317) 555-0123" },
  intake_age:             { en: "Child's age", es: "Edad del niño/a" },
  intake_age_ph:          { en: "e.g. 6", es: "ej. 6" },
  intake_grade:           { en: "Grade entering", es: "Grado que ingresa" },
  intake_grade_ph:        { en: "Choose a grade", es: "Elige un grado" },
  intake_notes:           { en: "Anything we should know", es: "Algo que debamos saber" },
  intake_notes_help:      { en: "IEP, learning needs, interests — optional.", es: "IEP, necesidades de aprendizaje, intereses — opcional." },
  intake_submit_parents:  { en: "Email me the Parents Guide", es: "Envíame la Guía para Padres" },
  intake_submit_activity: { en: "Email me the Activity Guide", es: "Envíame la Guía de Actividades" },
  intake_sending:         { en: "Sending…", es: "Enviando…" },
  intake_error:           { en: "Something went wrong. Please try again.", es: "Algo salió mal. Inténtalo de nuevo." },
  intake_success_title:   { en: "Check your inbox!", es: "¡Revisa tu bandeja!" },
  intake_success_body:    { en: "We just emailed your guide. Tap below to download it right now.", es: "Acabamos de enviarte la guía por correo. Toca abajo para descargarla ahora." },
  intake_success_download:{ en: "Download the guide", es: "Descarga la guía" },
  intake_success_tour:    { en: "Book a school tour", es: "Reserva un recorrido" },
  intake_success_tour_kicker: { en: "One more warm invite", es: "Un último gesto cálido" },
  intake_success_tour_title:  { en: "Come see SCL in person", es: "Ven a conocer SCL en persona" },
  intake_success_tour_body:   { en: "Pick a time that works for your family — we'll be ready with warm coffee and a real look inside.", es: "Elige un horario que funcione para tu familia — te recibimos con café calientito y un recorrido real." },
  intake_success_close:   { en: "Done", es: "Listo" },
  intake_privacy:         { en: "We use your email only to send SCL guides and event updates. Unsubscribe anytime.", es: "Usamos tu correo solo para enviarte guías y avisos de SCL. Cancela cuando quieras." },
  logout:                 { en: "Log out", es: "Cerrar sesión" },
  logout_confirm:         { en: "Log out and clear your session?", es: "¿Cerrar sesión y borrar tus datos?" },

  // Home / tour CTA
  home_tour_cta:      { en: "Book a school tour", es: "Reserva un recorrido" },
  home_tour_lead:     { en: "Come see SCL in person. Pick a time that works for your family.", es: "Ven a conocer SCL en persona. Elige un horario que funcione para tu familia." },
  home_parents_cta:   { en: "Get the SCL Parents Guide", es: "Obtén la Guía para Padres SCL" },
  home_parents_lead:  { en: "A free primer on how we teach, what a day looks like, and how to apply.", es: "Una guía gratuita sobre cómo enseñamos, cómo es un día y cómo aplicar." },

  // Grade choices
  grade_prek:  { en: "Pre-K", es: "Pre-K" },
  grade_k:     { en: "Kindergarten", es: "Kindergarten" },
  grade_1:     { en: "1st grade", es: "1er grado" },
  grade_2:     { en: "2nd grade", es: "2º grado" },
  grade_3:     { en: "3rd grade", es: "3er grado" },
  grade_4:     { en: "4th grade", es: "4º grado" },
  grade_5:     { en: "5th grade", es: "5º grado" },
  grade_6:     { en: "6th grade", es: "6º grado" },
  grade_7:     { en: "7th grade", es: "7º grado" },
  grade_8:     { en: "8th grade", es: "8º grado" },
};

export function t(key, lang = "en", vars = {}) {
  const entry = STRINGS[key];
  if (!entry) return key;
  let s = entry[lang] || entry.en || key;
  for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}
